import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const ApplyloanServices = createApi({
	reducerPath: "ApplyloanServices",
	tagTypes: "applyDta",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/user/",
		prepareHeaders: (headers, { getState }) => {
			const reducers = getState();
			const token = reducers?.AuthReducer?.userToken;
			headers.set("authorization", token ? `Bearer ${token}` : "");
			return headers;
		},
	}),
	endpoints: (builder) => {
		return {
			applyLoan: builder.mutation({
				query: (userData) => {
					return {
						url: "loans/store",
						method: "POST",
						body: userData,
					};
				},
				invalidatesTags: ["applyDta"],
			}),
			getApplyLoan: builder.query({
				query: () => {
					return {
						url: "loans/my-applications",
						method: "GET",
					};
				},
			}),
			providesTags: ["applyDta"],
		};
	},
});
export const { useApplyLoanMutation, useGetApplyLoanQuery } = ApplyloanServices;
export default ApplyloanServices;
